import React from 'react';
import { Typography } from '@mui/material';

const PageTitle = ({ children }) => (
  <Typography variant="h4" sx={{ mb: 2 }}>
    {children}
  </Typography>
);

export default PageTitle;
